import {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import OptionSet from "./option-set";
import {useWorkspaceTeam} from "../workspace-team/use-workspace-team";

export function useOptionSet() {
    const [loading, setLoading] = useState(false);
    const {user} = useSelector(state => state.auth);
    const dispatch = useDispatch();
    const getOptionSets = async () => {
        const optionSet = new OptionSet();
        setLoading(true);
        try {
            const _data = await optionSet.getAll({});
            return _data.data;
        } catch (e) {
            console.log(e);
        } finally {
            setLoading(false);
        }
    };

    return {getOptionSets};
}
